import React from 'react';

const toNumber = (input) => {
  if (typeof input === 'number') {
    return Number.isFinite(input) ? input : null;
  }

  if (typeof input === 'string') {
    const parsed = Number(input);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

const PercentageFormatter = ({ value, digits = 1, isRatio = true }) => {
  const numeric = toNumber(value);

  if (numeric === null) {
    return <span>—</span>;
  }

  const scaled = isRatio ? numeric * 100 : numeric;
  const formattedValue = `${scaled.toFixed(digits)}%`;

  return <span>{formattedValue}</span>;
};

export default PercentageFormatter;
